import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { RestrictProcessingStep } from "./restrict-processing/RestrictProcessingStep";
import { NotifyConsumer } from "./shared/NotifyConsumer";
import { VerifyConsumer } from "./shared/VerifyConsumer";

type Props = {
  request: DataRequestDetail;
};

export const RestrictProcessingSteps: React.FC<Props> = ({ request }) => {
  switch (request.state) {
    case "VERIFY_CONSUMER":
      return <VerifyConsumer />;
    case "RESTRICT_PROCESSING":
      return <RestrictProcessingStep />;
    case "NOTIFY_CONSUMER":
      return <NotifyConsumer />;
  }
  return null;
};
